// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";
import { css } from "styled-components";

export interface OrderTrackingNumberStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    orderTrackingNumberLink?: LinkPresentationProps;
}

export const orderTrackingNumberStyles: OrderTrackingNumberStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h6",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};

const styles = orderTrackingNumberStyles;

const OrderDetailsTrackingNumber = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.properties || !order.properties.upsTrackingNumber) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsTrackingNumber">
                {translate("Tracking Number")}
            </Typography>
            <Link
                href={order.properties.trackingNumberUrl}
                target="_blank"
                {...styles.orderTrackingNumberLink}
                aria-labelledby="orderDetailsTrackingNumber"
            >
                {order.properties.upsTrackingNumber}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsTrackingNumber,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
